import http from "../httpService"
import { OptionModel } from "@models/global"

class MasterDataService {
  public async filterEmployees(params: any): Promise<OptionModel[]> {
    const res = await http.get("api/services/app/Employees/GetList", {
      params,
    })
    const result = res.data.result
    return OptionModel.assigns(result || [])
  }
}

export default new MasterDataService()
